import { useSearchParams } from "next/navigation";

const BUILDER_EDITING_SEARCH_PARAM_KEY = "__builder_editing__";

export function useIsBuilderEditMode() {
  const searchParams = useSearchParams();

  return searchParams.has(BUILDER_EDITING_SEARCH_PARAM_KEY);
}
